import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const TemplateSearchTags = ({ searchTerm, clearSearchTerm }) => (
  <div className="asset-search-tag-container">
    <div className="asset-search-tag-label">Search results for</div>

    <div className="asset-search-tag-pill">
      {searchTerm}
      <FontAwesomeIcon
        icon={["far", "times-circle"]}
        className="asset-search-tag-icon"
        onClick={clearSearchTerm}
      />
    </div>
  </div>
);

TemplateSearchTags.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  clearSearchTerm: PropTypes.func.isRequired,
};

export default TemplateSearchTags;



// WEBPACK FOOTER //
// ./src/components/TemplateV2/TemplateSearchTags/TemplateSearchTags.js